export default __webpack_public_path__ + "static/media/mindmap_02.92d57fd4.png";